import BushaLoader from "app/components/BushaLoader";
import Text from "app/styles/Text";
import tw from "twin.macro";
import { useEffect } from "react";
import useRetrievePayment from "app/views/Transfer/Payment/hooks/useRetrievePayment";
import { useAppState } from "app/providers/AppStateProvider";
import { COMPLETED_STATUS } from "app/constants/variables";

export default function WaitingView({ onDone }: { onDone: () => void }) {
  const { payment, merchant, displayMode, parentOrigin, payment: paymentData } = useAppState();
  useRetrievePayment({
    id: payment?.id!,
    publicKey: merchant?.public_key,
  });

  useEffect(() => {
    if (
      Boolean(
        paymentData?.timeline.transfer_status === "funds_converted" ||
        paymentData?.timeline.transfer_status === "funds_received" ||
        paymentData?.timeline.transfer_status === "funds_delivered"
      )
    ) {
      if (displayMode === "INLINE" && parentOrigin) {
        const target = window.parent;

        target.postMessage(
          {
            status: COMPLETED_STATUS,
            data: paymentData,
          },
          parentOrigin
        );

        return;
      } else if (merchant.callback_url) {
        const callbackUrl = new URL(merchant.callback_url);
        callbackUrl.searchParams.set("status", COMPLETED_STATUS.toLowerCase());
        callbackUrl.searchParams.set("paymentRequestId", paymentData?.id!);
        window.location.href = callbackUrl.toString();
        return;
      }

      onDone();
    }
  }, [displayMode, parentOrigin, paymentData, onDone, merchant.callback_url]);

  return (
    <div tw="flex flex-col items-center text-center py-[40px] h-full pt-[40px]">
      <BushaLoader />

      <div tw="flex flex-col gap-[16px]">
        <Text css={tw`title-large`}>
          Processing payment
        </Text>

        <Text css={tw`body-large text-text-mid`}>
          Please wait while we process your transaction.
        </Text>
      </div>
    </div>
  );
}
